/**
 * Transforms a given text string into a slug:
 * - Converts the text to lowercase.
 * - Trims whitespace from the beginning and end of the text.
 * - Replaces spaces with hyphens.
 * - Removes non-alphanumeric characters, except hyphens.
 * - Replaces multiple consecutive hyphens with a single hyphen.
 * If the input text is `null` or `undefined`, it returns an empty string.
 *
 * @function
 * @param {string} [text] - The input text to be transformed into a slug.
 * @returns {string} - The transformed slug string.
 *
 * @example
 * // returns 'a-simple-text-string'
 * slugify('A Simple Text String');
 *
 * @example
 * // returns 'a-text-string-with-special-characters'
 * slugify('A Text String!@# With $%^ Special &*() Characters');
 *
 * @example
 * // returns 'a-text-string-with-multiple-spaces-and-hyphens'
 * slugify('  A   Text---String   With Multiple Spaces and Hyphens  ');
 *
 * @example
 * // returns ''
 * slugify(null);
 */
const slugify = (text) =>
  (text ?? "")
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-zA-Z0-9-]+/g, "")
    .replace(/--+/g, "-");

export default slugify;
